/**
 * Anzeige-Status einer Ausgabe (Liste + Editor).
 *   zu_pruefen  Entwurf / erkannt, noch nicht gebucht
 *   offen       gebucht als Rechnung, Kreditor-Posten offen
 *   teilbezahlt Kreditor-Posten teilweise bezahlt (Rest offen)
 *   bezahlt     gebucht und bezahlt (sofort oder per Bankabgleich)
 *   storniert   verworfen oder per Gegenbuchung storniert
 */
import { BADGE } from './dna';

export const EXPENSE_STATUS = {
  entwurf: { label: 'Entwurf', class: BADGE.draft },
  zu_pruefen: { label: 'Entwurf', class: BADGE.draft },
  offen: { label: 'Offen', class: BADGE.open },
  faellig: { label: 'Fällig', class: BADGE.due },
  teilbezahlt: { label: 'Teilbezahlt', class: BADGE.partial },
  gebucht: { label: 'Gebucht', class: BADGE.paid },
  bezahlt: { label: 'Bezahlt', class: BADGE.paid },
  storniert: { label: 'Storniert', class: BADGE.neutral },
};

export const QUELLE_LABEL = { ocr: 'OCR', pdf: 'PDF-Text', ki: 'KI', manuell: 'Manuell' };

/** Gebucht als „direkt bezahlt“, aber ohne Kreditor-Posten → keine Zahlung nachgewiesen (Altbestand) */
export const isPaidWithoutPayment = (e) => e.status === 'gebucht' && e.zahlungsart !== 'offen' && !e.open_item_id;

/** Rückfrage vor dem Löschen, je nach Zustand */
export function deleteConfirmText(e) {
  const label = (word) => [word, e.expense_no || e.beleg_nr].filter(Boolean).join(' ');
  if (e.status !== 'gebucht' && !e.journal_entry_id) return `${label('Entwurf')} endgültig löschen?`;
  return `${label('Ausgabe')} löschen?\n\nVerknüpfte Zahlungen werden storniert und Bankumsätze wieder freigegeben. `
    + 'Im Journal bleiben Buchung und Gegenbuchung erhalten (GoBD).';
}

/** Listenstatus aus Ausgabe + zugehörigem Kreditor-Posten */
export function displayStatus(expense, openItem, today) {
  if (expense.status === 'storniert') return 'storniert';
  if (expense.status !== 'gebucht') return 'zu_pruefen';
  if (expense.zahlungsart !== 'offen') return 'bezahlt';
  if (openItem?.status === 'paid') return 'bezahlt';
  if (openItem?.status === 'partial') return 'teilbezahlt';
  if (openItem?.due_date && openItem.due_date < today) return 'faellig';
  return 'offen';
}
